import React, { forwardRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormFieldRadioButtonGroup, RadioButton } from '@vwfs-bronson/bronson-react'
import { Formik } from 'formik'
import { FormField } from '../../../components/FormField'
import getInitialValues from './initial-values'
import { useSelector } from 'react-redux'
import { getStorefrontData } from '../../../services/redux/features/storefront.redux'
import { hasEmployeeDiscount } from '../../../services/common/utils'
import { PartnerType } from '../../../models/enums'

interface PreSelectionProps {
  onChange?: (values: any) => void
}

const PreSelection = forwardRef((props: PreSelectionProps , ref) => {
  const { t } = useTranslation()
  const { onChange } = props
  const storefrontData = useSelector(getStorefrontData)
  const [formValues, setFormValues] = useState() as any

  useEffect(() => {
    if (onChange) {
      onChange(formValues)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues])

  return (
    <Formik
      enableReinitialize
      initialValues={getInitialValues(storefrontData)}
      onSubmit={() => {}}
    >
      {(formProps) => {
        const { values } = formProps
        setFormValues(values)
        return (
          <FormField
            testId="partnerType"
            type="input"
            name="customerData.partnerType"
            required
            render={(fieldProps) => (
              <FormFieldRadioButtonGroup {...fieldProps} >
                <RadioButton
                  name={fieldProps.name}
                  value={PartnerType.PRIVATE}
                  defaultChecked={values?.customerData?.partnerType === PartnerType.PRIVATE}
                >
                  {t('personal-details:partnerType:PRIVATE')}
                </RadioButton>
                {!hasEmployeeDiscount() && (
                  <RadioButton
                    name={fieldProps.name}
                    value={PartnerType.BUSINESS}
                    defaultChecked={values?.customerData?.partnerType === PartnerType.BUSINESS}
                  >
                    {t('personal-details:partnerType:BUSINESS')}
                  </RadioButton>
                )}
              </FormFieldRadioButtonGroup>
            )}
          />
        )
      }}
    </Formik>
  )
})

export default PreSelection